import { sendEvent, EventCategories } from 'src/utils/gaService';
import { equal } from 'src/Library/Helper';
import { InquiryModes } from 'src/Library/Constants';

const { FCL, LCL, AIRCARGO, DOMESTIC, TRAILER,RPTL } = InquiryModes;
const sortByOptions = {
  transitDays: 'Transit Days',
  totalPrice: 'Total Price',
  totalFreight: 'Total Freight',
  locals: 'Locals',
  validityEnd: 'Validity End Date',
};

const searchOrginDestinationType = {
  ALL : 'ALL'
}

const DiscoverRatesViews = {
  RATES: 'Rates - Row Layout',
  ANALYTICS: 'Analytics',
  RATES_IN_COLUMN: 'Rates - Column Layout',
}

const sortByWhenNoLocals = {
  FCL: {
    transitDays: 'Transit Days',
    totalPrice: 'Total Price',
    oceanFreight: 'Ocean Freight',
    validityEnd: 'Validity End Date',
  },
  LCL: {
    transitDays: 'Transit Days',
    totalPrice: 'Total Price',
    oceanFreight: 'Base Freight',
    validityEnd: 'Validity End Date',
  },
  AIRCARGO: {
    transitDays: 'Transit Days',
    totalPrice: 'Total Price',
    oceanFreight: 'Freight',
    validityEnd: 'Validity End Date',
  },
  DOMESTIC: {
    transitDays: 'Transit Days',
    totalPrice: 'Total Price',
    oceanFreight: 'Freight',
    validityEnd: 'Validity End Date',
  },
  TRAILER: {
    transitDays: 'Transit Days',
    totalPrice: 'Total Price',
    oceanFreight: 'Freight',
    validityEnd: 'Validity End Date',
  },
  RPTL: {
    transitDays: 'Transit Days',
    totalPrice: 'Total Price',
    oceanFreight: 'Freight',
    validityEnd: 'Validity End Date',
  }
};

const weightOptions = ['kg', 'mt', 'lbs'];

const localsFilter = [
  { value: 'ORIGIN', label: 'Exclude Origin Charges' },
  { value: 'DESTINATION', label: 'Exclude Destination Charges' },
];

const isSellRatesContentVisible = (buyRatesViewPermission, activeKey) => {
  return buyRatesViewPermission && activeKey === 'SELL';
};

const openInquiriesText = (num) => {
  if (num === 1) {
    return `There is ${num} open inquiry for the selected parameters.`;
  }
  return `There are ${num} open inquiries for the selected parameters.`;
};

enum LINKING_STATUS {
  LINKED = 'LINKED',
  NON_LINKED = 'NON_LINKED',
  REQUESTED = 'REQUESTED',
}

const FFSelectedText = 'FF(s) whose rates are selected';
const FFSelectedSendInquiry = 'Select FF for Rate Negotiation';

const FFStrategicText = "Shipsy's Forwarder(s)";
const FFStrategicSendInquiry = 'Shipsy’s FF with no rates';

const selectFFText = '+ Select additional forwarder(s) to send inquiry';

const getGAEventCategory = (type, action, label = '') => {
  if (type === 'FF') {
    sendEvent(EventCategories.DISCOVER_RATES_SEARCH_FF, action, label);
  } else {
    sendEvent(EventCategories.DISCOVER_RATES_SEARCH_SHIPPER, action, label);
  }
};

const gridPortCodeList = {
  POLCodeList: ['INNSA', 'INMUN', 'INTKD', 'INMAA', 'INDER', 'INLDH'],
  PODCodeList: [
    'AEJEA',
    'SADMM',
    'LKCMB',
    'DEHAM',
    'NLRTM',
    'KEMBA',
    'GHTEM',
    'QAHMD',
    'TZDAR',
    'HKHKG',
    'SAJED',
    'BEANR',
  ],
};

enum GridView {
  GRID = 'GRID',
  LIST = 'LIST',
}

const portLimit = {
  POL: 8,
  POD: 15,
};

enum savedInLocalStorage {
  SAVED_SEARCH = 'savedSearch',
  SAVED_GRID_SEARCH = 'savedGridSearch',
}

enum FFType {
  MY_FF = 'MyFF',
  STRATEGIC_FF = 'strategicFF',
  RATE_FF = 'RateFF',
}

const setSavedArray = (object, SavedValues, arrayLength = 10): void => {
  const duplicateSearch = SavedValues.findIndex((item) => {
    return equal(item, object);
  });
  if (duplicateSearch !== -1) {
    SavedValues.splice(0, 0, SavedValues.splice(duplicateSearch, 1)[0]);
  } else {
    SavedValues.length >= arrayLength && SavedValues.pop();
    SavedValues.unshift(object);
  }
  return SavedValues;
};

const directServices = ['Port Service'];
const serviceLabelMap = { 'Port Service': 'Locals' };

const getDiscoverSearchBarMargin = function(isDiscoverPage, isLandingPage, mode, orgType){
  if (mode !== FCL && !isLandingPage && !isDiscoverPage){
    return '8px 14% 12px'
  } else if (mode === FCL && !isLandingPage && !isDiscoverPage){
    return orgType === 'SHIPPER' ? '8px 5% 12px' : '8px 2% 12px';
  }
  const horizontalMargin = mode !== FCL ? '15%' : '10%'
  return isDiscoverPage ? `8px ${horizontalMargin} 12px` : isLandingPage || orgType === 'SHIPPER' ? '8px 0 12px' : '8px 2% 12px';
}

export const getFormItemClassName = (isLandingPage, classes) => isLandingPage ? classes.landingPageErrorMessage : classes.errorMessage

export const modeSpecificChargeNameMap = {
  LCL: { freight: 'Basic Freight' },
  AIRCARGO: { freight: 'Air Freight' },
  FCL: { freight: 'Ocean Freight' }
}

export const modeSpecificChargeDisplayNameMap = {
  LCL: { freight: 'Base Freight' },
  AIRCARGO: { freight: 'Freight' },
  FCL: { freight: 'Ocean Freight' }
}

export const shippingModes = {
  FCL, LCL, AIR: AIRCARGO, ROAD: DOMESTIC, TRAILER, RPTL
};
export const FFModes = { FCL };

export const removeTrailingZero = (value) => {
  let numstr = value?.toString() || '';
  while (numstr.includes('.') && numstr[numstr.length - 1] === "0") {
    numstr = numstr.slice(0, -1)
    if (numstr[numstr.length - 1] !== "0" || numstr[numstr.length - 3] === ".") { break; }
  }
  return numstr;
}

export const defaultPolAir = {
  code: "DEL",
  country: "India",
  countryCode: "IND",
  countryId: "102",
  countryName: "India",
  id: "3733",
  flagS3Link: "https://shipsy-public-assets.s3-us-west-2.amazonaws.com/shipper-dashboard/country-flags/in.png",
  name: "Indira Gandhi Intl, Delhi",
  type: "AIR"
}

export const defaultPodAir = {
  code: "EWR",
  country: "United States",
  countryCode: "USA",
  countryId: "239",
  countryName: "United States",
  id: "15337",
  flagS3Link: "https://shipsy-public-assets.s3-us-west-2.amazonaws.com/shipper-dashboard/country-flags/us.png",
  name: "Newark International Airport",
  type: "AIR"
}

export const chargeListUnitTypeMap = {
  'Per Container': 'Container',
	'Per BL': 'BL',
	'Per KG': 'KG',
	'Per CBM': 'CBM',
	'Per AWB': 'AWB',
	'Per MT': 'MT',
	'Per Trailer': 'Trailer',
	'Per Pallet': 'Pallet',
	'Per Box': 'Box',
	'Per Drum': 'Drum',
	'Per Roll': 'Roll',
	'Per IBC': 'IBC',
	'Per Oval Roll': 'Oval Roll',
	'Per Vehicle': 'Vehicle',
	'Per Bale': 'Bale',
	'Per Carton': 'Carton',
	'Per Packing': 'Packing',
	'Min Shipment': 'Min Shipment',
  'Per Contract': 'Contract',
}

export const modeWiseUnit = {
  FCL: 'CN',
  LCL: 'cbm',
  AIRCARGO: 'kg',
  RPTL: 'cbm', // RPTL uses LCL charge units
}

const modeWiseStuffingDestuffingServices = {
  [InquiryModes.FCL]: ["Transportation Service", "Freight Service", "Custom Clearance Service"],
  [InquiryModes.LCL]: ["Transportation Service", "Freight Service"],
  [InquiryModes.AIRCARGO]: ["Transportation Service", "Freight Service"],
};

const domesticModeCargoList = [
  {
    id: 'GENERAL - ALL',
    key: { cargo: 'GENERAL', product: 'ALL' },
    label: { cargo: 'General', product: 'All' },
    showAlways: true,
    value: 'General - All',
  },
  {
    id: 'HAZ - ALL',
    key: { cargo: 'HAZ', product: 'ALL' },
    label: { cargo: 'Haz', product: 'All' },
    showAlways: true,
    value: 'Haz - All',
  },
  {
    id: 'REEFER - ALL',
    key: { cargo: 'REEFER', product: 'ALL' },
    label: { cargo: 'Reefer', product: 'All' },
    showAlways: true,
    value: 'Reefer - All',
  },
];

const groupRadiusUnitMap = {
  km: 'KMs',
  mi: 'Miles',
};

export {
  sortByOptions,
  searchOrginDestinationType,
  localsFilter,
  weightOptions,
  sortByWhenNoLocals,
  isSellRatesContentVisible,
  openInquiriesText,
  LINKING_STATUS,
  FFSelectedText,
  FFSelectedSendInquiry,
  selectFFText,
  getGAEventCategory,
  gridPortCodeList,
  GridView,
  portLimit,
  savedInLocalStorage,
  FFType,
  setSavedArray,
  FFStrategicText,
  FFStrategicSendInquiry,
  directServices,
  serviceLabelMap,
  getDiscoverSearchBarMargin,
  modeWiseStuffingDestuffingServices,
  domesticModeCargoList,
  DiscoverRatesViews,
  groupRadiusUnitMap
};
